import type { SVGProps } from "react";

import { cn } from "@/utils/cn";

type IconProps = SVGProps<SVGSVGElement>;

// Figma "icons / system" arrow: an 11.2px glyph inset in the 16px frame
export const ArrowRight = ({ className, ...props }: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
    className={cn("size-ds-icon-base", className)}
  >
    <path
      d="M8.32109 13.6L7.2 12.4223L10.5578 8.86021H2.4V7.13979L10.5578 7.13979L7.2 3.58351L8.32109 2.4L13.6 8L8.32109 13.6Z"
      fill="currentColor"
    />
  </svg>
);
